export const HEALTH_FACTOR_SAFE_THRESHOLD = 2;
export const HEALTH_FACTOR_MODERATE_THRESHOLD = 1.25;
export const HEALTH_FACTOR_LIQUIDATION_THRESHOLD = 1;

export const HEALTH_FACTOR_SAFE_MAX_THRESHOLD = 1.3;
